import { useState } from "react";
import { notificacionError } from "../../../../components/Alerts";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { iniciarFase } from "../../../../ts/api/API";
import { Constantes } from "../../../../ts/constantes";
import { useQueryClient } from "@tanstack/react-query";

interface IniciarFaseProps extends BaseModalProps {
	readonly idOF: number;
	readonly idFase: number;
}
export function ModalIniciarFase(props: IniciarFaseProps) {
	const queryClient = useQueryClient();
	const [fecha, setFecha] = useState(new Date().toISOString().split("T")[0]);

	const iniciar = () => {
		const date = new Date(fecha);
		const timestamp = Math.trunc(date.getTime() / 1000);

		if (isNaN(timestamp)) {
			notificacionError("Fecha no válida");
			return;
		}

		void iniciarFase({
			idOF: props.idOF,
			idFase: props.idFase,
			fechaInicio: timestamp,
		}).then((result) => {
			if (result.status == "error") {
				notificacionError(result.message);
				return;
			}

			return queryClient.invalidateQueries({ queryKey: ["getFasesOF", props.idOF] }).then(() => {
				props.close();
			});
		});
	};

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h2 className="modal-title">
					<span>Iniciar Fase:</span>
					<span>OF #{props.idOF}</span>
					{Constantes.existenFases ? (
						<span>- Fase {props.idFase}</span>
					) : null}
				</h2>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="content-box big-box">
					<div className="containerLbl">
						<label htmlFor="inputFechaFase" className="labelsForm">Fecha</label>
						<input className="inputsForm" id="inputFechaFase" type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cancelar</button>
				<button type="button" className="btnPrimary" onClick={iniciar}>Iniciar Fase</button>
			</div>
		</BaseModal>
	);
}